import Vue from 'vue';
export const eventHub = new Vue();



//////////////////
// WEBPACK FOOTER
// ./config/eventhub.js
// module id = null
// module chunks = 